import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { login } from '../api';
import { useTheme } from '../context/ThemeContext';

function Login() {
  const { darkMode } = useTheme();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(password);
      navigate('/admin/meny');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <SEO title="Logg inn" path="/login" noindex />
      <div className="w-full max-w-sm">
        <div className={`rounded-2xl p-8 border ${darkMode ? 'bg-slate-800 bg-opacity-60 border-slate-700' : 'bg-white border-stone-200 shadow-md'}`}>
          <h1 className={`text-2xl font-bold mb-6 text-center ${darkMode ? 'text-white' : 'text-stone-900'}`}>Admin</h1>

          {error && (
            <div className="mb-4 p-3 rounded-xl bg-red-500 bg-opacity-20 text-red-400 text-sm border border-red-500 border-opacity-30">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Passord"
              autoFocus
              required
              className={`w-full px-4 py-3 border rounded-xl focus:outline-none focus:border-teal-500 focus:ring-1 focus:ring-teal-500 transition-colors mb-4 ${darkMode ? 'bg-slate-700 border-slate-600 text-gray-200 placeholder-gray-500' : 'bg-stone-50 border-stone-300 text-stone-800 placeholder-stone-400'}`}
            />
            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 bg-teal-500 text-white font-bold rounded-xl hover:bg-teal-400 disabled:opacity-50 transition-colors"
            >
              {loading ? 'Logger inn...' : 'Logg inn'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
